var map = {
	"./asset.svg": 994,
	"./changerequests.svg": 9861,
	"./date.svg": 2511,
	"./drawings.svg": 2338,
	"./electrical.svg": 6509,
	"./equipment.svg": 5921,
	"./fire-safety.svg": 5458,
	"./jb-dark.svg": 5464,
	"./jb-dashbaord-logo.svg": 6144,
	"./jb-logo.svg": 4697,
	"./line-drawing.svg": 2660,
	"./login-arw.svg": 8601,
	"./login-right-bg.svg": 573,
	"./logout-ico.svg": 8365,
	"./manuals.svg": 1692,
	"./mechanical.svg": 8594,
	"./myaccount-ico.svg": 2218,
	"./password-ico.svg": 3232,
	"./schedules.svg": 5899,
	"./schematics.svg": 1301,
	"./support-ico.svg": 2248,
	"./upload.svg": 4784,
	"./user-ico.svg": 4150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;